import { render, staticRenderFns } from "./place-add.vue?vue&type=template&id=b91d9cda&scoped=true&"
import script from "./place-add.vue?vue&type=script&lang=js&"
export * from "./place-add.vue?vue&type=script&lang=js&"
import style0 from "./place-add.vue?vue&type=style&index=0&id=b91d9cda&scoped=true&lang=css&"
import style1 from "./place-add.vue?vue&type=style&index=1&id=b91d9cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91d9cda",
  null
  
)

export default component.exports